export default "__VITE_PUBLIC_ASSET__99bcb845__"